import cubitslogo from "./../cubits-logo.png";
import { Image } from "antd";
import "./../styles/logo.scss";


const Logo = ({ preview = false, width, height }) => {
    return (
        <div
            className="app-logo"
            style={{
                width,
                height,
            }}
        >
            <Image
                alt="Cubits Logo"
                src={cubitslogo}
                preview={preview}
                className="app-logo__image"
            />
            <div className="app-logo__slogan trade-mark">ML Boosted</div>
        </div>
    );
};

export default Logo;